import { Comments, Flag, ExclamationCircle, Bell, Envelope } from '@assets/svgs';
import { ReactNode } from 'react';
import { NotificationType, IconName } from '@lio/rule-engine';

const iconStyles = {
  width: '16px',
  height: '16px',
};

// TODO use color in wrapper

export const FallbackIcon = <Bell id='bellIcon' style={iconStyles} />;

export const icon: Record<IconName, ReactNode> = {
  [IconName.Bell]: <Bell id='bellIcon' style={iconStyles} />,
  [IconName.Flag]: <Flag id='flagIcon' style={iconStyles} />,
  [IconName.Comment]: <Comments id='commentIcon' style={iconStyles} />,
  [IconName.ExclamationCircle]: <ExclamationCircle id='circleIcon' style={iconStyles} />,
  [IconName.Envelope]: <Envelope id='envelopeIcon' style={iconStyles} />,
};

export const getNotificationUrl = {
  // quote
  [NotificationType.TaskAssignment]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.NewMessage]: ({ quoteId, policyId }: { quoteId?: string; policyId?: string }) => {
    if (policyId) {
      return `/policy/${policyId}?actions=messages`;
    }
    return `/quote/${quoteId}?sidebarItem=messages`;
  },
  [NotificationType.SubmissionStatusChange]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.PolicyStatusChange]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.RenewalStatusChange]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.ProcessFailed]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.Reminder]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.NewSubmission]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.NewRenewal]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.QuoteReleased]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.RenewalReleased]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.SubmissionComplete]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.QuoteOrRenewalDeclined]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.QuoteOrRenewalBound]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.QuoteOrRenewalReferred]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.SubmissionLapsed]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.QuoteOrRenewalCanceled]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.ExpirationReminder]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.UWReassigned]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.ExpirationReminderLSIC]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  [NotificationType.SubmissionLapsedLSIC]: ({ quoteId }: { quoteId?: string }) => `/quote/${quoteId}`,
  // [NotificationType.NewPolicyMessage]: ({ policyId }: { policyId?: string }) => `/policy/${policyId}`, // link is sent so this is not needed

  // go to billing account
  [NotificationType.PolicyCancelled]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/account/${billingAccountId}`,
  [NotificationType.PolicyCancelledNonPay]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/account/${billingAccountId}`,
  [NotificationType.PolicyReinstated]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/account/${billingAccountId}`,
  [NotificationType.NewInvoice]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/account/${billingAccountId}`,
  [NotificationType.AutopaymentAccountIneligible]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/account/${billingAccountId}?tab=invoices`,

  [NotificationType.RescindIntentToCancelNotice]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/account/${billingAccountId}`,

  // go to make a payment
  // TODO switch to osAccountNumber, which is currently not returned by searchNotifications
  [NotificationType.PaymentDueDateUpcoming]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/new?accountNumber=${billingAccountId}`,
  [NotificationType.IntentToCancelNotice]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/new?accountNumber=${billingAccountId}`,
  [NotificationType.AutopaymentFailed]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/new?accountNumber=${billingAccountId}`,
  [NotificationType.AutopaymentInvalidExceedsTotalPayment]: ({ billingAccountId }: { billingAccountId?: string }) =>
    `/payments/new?accountNumber=${billingAccountId}`,

  // go to payment detail
  [NotificationType.PaymentCompleted]: ({ paymentRequestId }: { paymentRequestId?: string }) =>
    `/payments/payment-detail/${paymentRequestId}`,

  // go to settings
  [NotificationType.AutopaymentInvalidPaymentMethod]: () => `/settings/payment-methods`,
  [NotificationType.AutopaymentUpcoming]: () => '/settings/payment-methods',
};
